// Define a class for the Swiper component that extends the HTMLElement class
class PromoBarComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();

    document.addEventListener("shopify:section:load", this.initSwiper.bind(this));
    document.addEventListener("shopify:section:reorder", this.initSwiper.bind(this));
    document.addEventListener("shopify:section:select", this.initSwiper.bind(this));
    document.addEventListener("shopify:block:select", this.initSwiper.bind(this));
  }

  initSwiper() {
    const autoplayDelay = this.getAttribute("data-autoplay-delay") || 5000;
    const sliderEffect = this.getAttribute("data-slider-effect") || "fade";

    if (this.swiper && this.swiper.destroy) this.swiper.destroy(true, true);

    this.swiper = new Swiper(this, {
      speed: 400,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: parseInt(autoplayDelay),
      },
      effect: sliderEffect,
      fadeEffect: {
        crossFade: true,
      },
    });

    // WCAG 2.2.2: honor reduced-motion — start paused.
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (this.reducedMotion && this.swiper.autoplay) this.swiper.autoplay.stop();

    this.initPauseControl();
  }

  // WCAG 2.2.2 (Pause, Stop, Hide): auto-rotating content needs a user control.
  initPauseControl() {
    const button = this.querySelector(".announcement-bar__pause");
    if (!button) return;

    const setState = (paused) => {
      button.setAttribute(
        "aria-label",
        paused ? "Play announcement rotation" : "Pause announcement rotation"
      );
      button.querySelector(".announcement-bar__pause-icon--pause").classList.toggle("hidden", paused);
      button.querySelector(".announcement-bar__pause-icon--play").classList.toggle("hidden", !paused);
    };

    setState(this.reducedMotion);

    if (!button.dataset.bound) {
      button.dataset.bound = "true";
      button.addEventListener("click", () => {
        const isRunning = this.swiper.autoplay && this.swiper.autoplay.running;
        if (isRunning) {
          this.swiper.autoplay.stop();
        } else {
          this.swiper.autoplay.start();
        }
        setState(isRunning);
      });
    }
  }
}

// Define the custom element
customElements.define("promo-bar", PromoBarComponent);
